import type { TranslationTree } from '../../types';

export const modules: TranslationTree = {
  modules: {
    labels: {
      tracabilite: 'Traçabilité',
      analytic: 'Analyses',
      'adaptcut-connector': 'Connecteur Adaptcut',
      'machine-learning': 'Machine Learning',
      labelisation: 'Étiquetage',
      'tool-recommender': "Éco-conception d'outil",
    },
    descriptions: {
      tracabilite: 'Suivi en temps réel des soumissions de production.',
      analytic: 'Statistiques avancées et tableaux de bord personnalisés.',
      'adaptcut-connector': 'Passerelle des données Adaptcut (Odoo) vers ToolLife.',
      'machine-learning': 'Modèles prédictifs pour anticiper les anomalies.',
      labelisation: "Sessions d'étiquetage d'images pour l'entraînement des modèles.",
      'tool-recommender': "Recommandations d'outils de fraisage par algorithme génétique.",
    },
  },
};
